export default __webpack_public_path__ + "static/media/Bandeau 22bis.e935c2a8.jpg";